import React from 'react';

import { useIntl } from 'react-intl';

import { routes } from 'utils/routing';

import { PrepaidTransferBalanceLink } from './styled';

function PrepaidTransferBalance() {
  const { formatMessage } = useIntl();
  const cardAlias = formatMessage({ id: 'cardAlias.bk' });
  return (
    <PrepaidTransferBalanceLink testID="prepaid-transfer-balance" to={routes.transferGiftCard}>
      {formatMessage({ id: 'transferBalanceFromAnotherCard' }, { cardAlias })}
    </PrepaidTransferBalanceLink>
  );
}
export default PrepaidTransferBalance;
